import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
const BLACK_LIST = ['gp@ritewayautotransport.com'];
export class UserGuard {
    constructor(router) {
        this.router = router;
    }
    canActivate() {
        this.user = JSON.parse(localStorage.getItem('USER_DATA'));
        if (BLACK_LIST.includes(this.user.username)) {
            this.router.navigateByUrl('/main/orders');
        }
        return true;
    }
}
UserGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserGuard_Factory() { return new UserGuard(i0.ɵɵinject(i1.Router)); }, token: UserGuard, providedIn: "root" });
